<div (click)="onClick($event)" class="rect-button-container">
  <button
    *ngIf="raised; else notRaised"
    [color]="color"
    [class.is-loading]="isLoading"
    [disabled]="disabled"
    [type]="type"
    mat-raised-button
  >
    <ng-container *ngTemplateOutlet="tmp"></ng-container>
  </button>
  <ng-template #notRaised>
    <button
      [color]="color"
      [class.is-loading]="isLoading"
      [disabled]="disabled"
      [type]="type"
      mat-button
    >
      <ng-container *ngTemplateOutlet="tmp"></ng-container>
    </button>
  </ng-template>
  <mat-progress-bar
    *ngIf="isLoading"
    class="animated fadeIn"
    color="accent"
    mode="indeterminate"
  ></mat-progress-bar>
</div>

<ng-template #tmp>
  <ng-container *ngIf="i18nKey; else transclusion">{{
    i18nKey | wzI18n
  }}</ng-container>
  <ng-template #transclusion>
    <ng-content></ng-content>
  </ng-template>
  <mat-icon *ngIf="matIcon">{{ matIcon }}</mat-icon>
</ng-template>
